// Third party
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Components
import { IRootState } from './type';
import { reducers } from './reducers';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils';

const initialState: IRootState = {
  sessions: null,
  scenarios: [],
  transactions: [],
  repetitions: [],
  weapon_presentation: [],
  stability_presentation: [],
};

export const slice = createSlice({
  name: STORE_SLICES.SHOOTING_DATA,
  initialState,
  reducers,
});

const shootingDataActions = slice.actions;

const shootingDataPersistConfig = {
  key: PERSIST_KEYS.SHOOTING_DATA,
  storage,
};

export { shootingDataActions, initialState };
export default persistReducer(shootingDataPersistConfig, slice.reducer);
